import React from 'react';
import { Input, Button, DatePicker, Tooltip } from 'components';
import { SurveyService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import moment from 'moment';
import { AddIcon, TrashIcon } from 'assets/icons';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
}

class CreateSurvey extends React.Component<Props> {

	state = {
		form: {
			expiration_date: '',
			name: ''
		},
		questions: []
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					expiration_date: this.props.item?.expiration_date ? moment(this.props.item?.expiration_date).toDate() : ''
				},
				questions: this.props.item?.questions || []
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (this.state.questions.length == 0) {
			Globals.showError("Por favor, ingrese al menos una pregunta");
			return;
		}

		for (let i = 0; i < this.state.questions.length; i++) {
			const question: any = this.state.questions[i];

			if (!question?.name) {
				Globals.showError("Por favor, ingrese todas preguntas");
				return;
			}

			if (question?.options?.length < 2) {
				Globals.showError("Por favor, ingrese al menos 2 respuestas para cada pregunta");
				return;
			}

			for (let j = 0; j < question?.options?.length; j++) {
				if (!question?.options[j].name) {
					Globals.showError("Por favor, ingrese todas respuestas");
					return;
				}
			}
		}		

		if (this.props.item != null) {
			await SurveyService.admin.update({
				survey_id: this.props.item?.id,
				...this.state.form,
				expiration_date: this.state.form.expiration_date && moment(this.state.form.expiration_date).format('YYYY-MM-DD'),
				questions: JSON.stringify(this.state.questions)
			});
			Globals.showSuccess("Se ha modificado la encuesta correctamente");
			this.props.onClose();
		}
		else {
			await SurveyService.admin.create({
				...this.state.form,
				expiration_date: this.state.form.expiration_date && moment(this.state.form.expiration_date).format('YYYY-MM-DD'),
				questions: JSON.stringify(this.state.questions)
			});
			Globals.showSuccess("Se ha creado la encuesta correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		let questions: any = [...this.state.questions];
		questions.push({
			name: '',
			options: []
		});
		this.setState({
			questions
		});
	}

	addOption = (index: number) => {
		let questions: any = [...this.state.questions];
		questions[index].options.push({
			name: ''
		});
		this.setState({
			questions
		});
	}

	changeItem = (e: any, index: number) => {
		let questions: any = [...this.state.questions];
		questions[index][e.target.name] = e.target.value;
		this.setState({
			questions
		});
	}

	delete = (e: any, index: number) => {
		e.preventDefault();
		let questions: any = [...this.state.questions];
		questions.splice(index,1);
		this.setState({
			questions
		});
	}

	changeResponse = (e: any, index: number, option_index: number) => {
		let questions: any = [...this.state.questions];
		questions[index].options[option_index][e.target.name] = e.target.value;
		this.setState({
			questions
		});
	}

	deleteResponse = (e: any, index: number, option_index: number) => {
		e.preventDefault();
		let questions: any = [...this.state.questions];
		questions[index].options.splice(option_index,1);
		this.setState({
			questions
		});
	}
	
	render() {
		const questions: any = this.state.questions;

		return (
			<div id="modal-create-survey">
				<form onSubmit={ this.submit }>
					<div className="container-inputs">
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.name }
									name="name" 
									label="Nombre"
									onChange={ this.change } />
							</div>
							<div className="col-md-6">
								<DatePicker
									label="Fecha de expiración"
									placeholder="Fecha"
									minDate={ moment().add(1,'day').toDate() }
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'expiration_date'
											}
										});
									} }
									value={ this.state.form.expiration_date }
								/>
							</div>
							<div className="col-md-12">
								<div className="row row-title">
									<div className="col-md-8">
										<h3>Preguntas</h3>
									</div>
									<div className="col-md-4 text-right">
										<button className="btn btn-add" type="button" onClick={ this.add }>
											<img src={ AddIcon } />
										</button>
									</div>
								</div>
								{
									questions?.map((item: any, index: number) => {
										return (
											<>
												<div className="container-question">
													<div style={{ flex: 1 }}>
														<Input
															color="white"
															value={ item.name }
															name="name" 
															placeholder="Pregunta"
															onChange={ (e: any) => this.changeItem(e,index) } />
													</div>
													<div>
														<button className="btn btn-add" type="button" onClick={ () => this.addOption(index) }>
															<img src={ AddIcon } />
														</button>
													</div>
													<div>
														<Tooltip title="Eliminar">
															<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,index) }>
																<img src={ TrashIcon } />
															</a>
														</Tooltip>
													</div>	
												</div>
												{
													item?.options?.map((option: any, option_index: number) => {
														return (
															<div className="container-question response">
																<div style={{ flex: 1 }}>
																	<Input
																		color="white"
																		value={ option.name }
																		name="name" 
																		placeholder="Respuesta"
																		onChange={ (e: any) => this.changeResponse(e,index,option_index) } />
																</div>
																<div>
																	<Tooltip title="Eliminar">
																		<a className="link-icon" href="#" onClick={ (e: any) => this.deleteResponse(e,index,option_index) }>
																			<img src={ TrashIcon } />
																		</a>
																	</Tooltip>
																</div>	
															</div>
														)
													})
												}
											</>
										)
									})
								}
							</div>
						</div>
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateSurvey;